// extracted by mini-css-extract-plugin
export default {"row":"ConsolidateCustomerDataReview_row__xpZ+7","input":"ConsolidateCustomerDataReview_input__sSgGB"};